<!--
 * @Descripttion: 登陆方式切换组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2024-12-13 14:46:03
-->
<template>
  <div>
    <!-- <a-tabs v-model="activeTab" :key="orgListKey" :tabBarStyle="{ borderBottom: 'unset' }" @change="tabChange"> -->
    <div class="login-title">
      {{ $t(loginConfig.authType === 'center_auth' ? 'base.accountLogin' : 'base.accountLoginOld') }}
      <a-tooltip v-show="loginConfig.authType === 'center_auth'">
        <template slot="title"> <span v-html="loginConfig.content" style="white-space: pre-line"></span></template>
        <a-icon type="info-circle" style="margin-left: 10px" />
      </a-tooltip>
    </div>

    <loginCode />
    <!-- <a-tab-pane key="code" tab="账号登录">
        <loginCode />
      </a-tab-pane>
    <a-tab-pane key="password" tab="密码登录">
        <LoginForm />
      </a-tab-pane>
    </a-tabs> -->
  </div>
</template>

<script>
import LoginForm from './login-form.vue'
import loginCode from './login-code.vue'

export default {
  components: {
    LoginForm,
    loginCode,
  },
  data() {
    return {
      activeTab: 'code', // 默认值
      orgListKey: Date.now(),
    }
  },
  computed: {
    loginConfig() {
      return this.$store.state.user.loginConfig || ''
    },
    locale() {
      return this.$store.getters.lang
    }
  },
  methods: {
    loadOrgList() {
      this.orgListKey += 1
    },
    tabChange(val) {
      let data = {
        loginType: 'login',
        activeTab: val,
        isAgree: false,
      }
      this.loadOrgList()
      this.$store.commit('setLoginInfo', data) // 假设 `setLoginInfo` 是通过 mutation 修改 state
    },
  },
}
</script>

<style lang="less" scoped>
.login-title {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  line-height: 33px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-bottom: 25px;
}

.form-login {
  position: fixed;
  left: 54px;
  top: 100px;
}

.title {
  height: 60px;
  display: flex;
  align-items: center;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 20px;
  color: #ffffff;
  cursor: pointer;
  .anticon-left {
    margin-right: 20px;
    height: 14px;
    width: 7px;
  }
}

/deep/.ant-tabs-tab {
  font-size: 20px;
  font-weight: 500;
  color: #cccc;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-style: normal;
}
/deep/.ant-tabs-tab-active {
  color: #ffff;
}

/deep/.ant-tabs-nav::before {
  height: 0px;
}

/deep/ .ant-tabs-nav::before {
  border-bottom: none !important;
}
</style>
